/**
 * OrderForm Types - Type definitions for OrderForm components
 */
import { PositionInfo } from '../../types/portfolio';

export type OrderSide = 'buy' | 'sell';
export type AssetType = 'stock';

export interface OrderFormProps {
  onOrderSuccess?: () => void;
}

export interface OrderFormState {
  symbol: string;
  quantity: string;
  side: OrderSide;
  assetType: AssetType;
  loading: boolean;
  error: string | null;
  showToast: boolean;
  toastMessage: string;
  toastType: 'success' | 'error';
}

export interface PositionState {
  positions: PositionInfo[];
  positionsLoading: boolean;
  selectedPosition: PositionInfo | null;
  accountCash: number;
}

export interface PriceState {
  currentPrice: number | null;
  priceLoading: boolean;
  estimatedAmount: number;
}

export const MIN_ORDER_AMOUNT = 10; // $10
